import React from 'react';
import { Breadcrumbs, type BreadcrumbsProps } from '../molecues/Breadcrumbs';
import { SearchBar } from '../molecues/SearchBar';
import { ProfileMenu } from '../molecues/ProfileMenu';

/**
 * DashboardHeader Component - Organism Level
 * 
 * Header for dashboard pages with breadcrumbs, search, and actions
 * 
 * Features:
 * - Breadcrumb navigation
 * - Global search
 * - Settings
 * - Profile menu
 * - Responsive design
 */

export interface DashboardHeaderProps {
  /** Breadcrumb items */
  breadcrumbs?: BreadcrumbsProps['items'];
  /** Search handler */
  onSearch?: (query: string) => void;
  /** Whether to show search bar */
  showSearch?: boolean;
  /** Custom actions to show in header */
  actions?: React.ReactNode;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  breadcrumbs,
  onSearch,
  showSearch = true,
  actions,
}) => {
  // const handleSettingsClick = () => {
  //   // Handle settings click
  //   console.log('Settings clicked');
  // };

  return (
    <header className="sticky top-0 z-30">
      <div className="flex items-center justify-between gap-4 px-6 py-4 backdrop-blur-md">
        {/* Left Section: Breadcrumbs */}
        <div className="flex-shrink-0">
          <Breadcrumbs items={breadcrumbs} />
        </div>

        {/* Right Section: Search, Actions, Profile */}
        <div className="flex items-center gap-3">
          {/* Search Bar */}
          {showSearch && (
            <div className="hidden md:block w-64 lg:w-80">
              <SearchBar
                placeholder="Search here"
                onSearch={onSearch}
                showShortcut={true}
              />
            </div>
          )}

          {/* Custom Actions */}
          {actions}

          {/* Settings */}
          {/* <IconButton
            icon={
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            }
            ariaLabel="Settings"
            variant="ghost"
            onClick={handleSettingsClick}
          /> */}

          {/* Profile Menu */}
          <div className="">
            <ProfileMenu />
          </div>
        </div>
      </div>

      {/* Mobile Search Bar */}
      {showSearch && (
        <div className="md:hidden px-6 pb-4">
          <SearchBar
            placeholder="Search here"
            onSearch={onSearch}
            showShortcut={false}
          />
        </div>
      )}
    </header>
  );
};

export default DashboardHeader;

